import { create } from 'zustand';

export const useContextMenuActionStore = create((set) => ({
    action: null,
    data: null,
    setAction: (data) => set((prevState) => ({ ...prevState, ...data })),
}));

export default useContextMenuActionStore;
